import iconSVG from "../icons/Glass_Standard.svg";
import instagramSVG from "../icons/instagram.svg";
export const landingPageUrl = "/";

const landingPageIcon = iconSVG;
const instagramIcon = instagramSVG;
export { landingPageIcon, instagramIcon };
